import React from 'react';
import MoonLoader from 'react-spinners/MoonLoader';
import { LoaderStyles } from './LoaderStyles';

interface LoaderProps {
  color?: string;
  size?: number;
}

function Loader({ color, size }: LoaderProps) {
  return (
    <LoaderStyles>
      <MoonLoader
        color={color || '#000'}
        size={size || 100}
      />
    </LoaderStyles>
  );
}

export default Loader;
